import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import type { ItemPriceHistoryEntry } from "../../types/market";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const CURRENCY_COLORS: Record<string, { border: string; background: string }> = {
  Gold: { border: "#e0b93d", background: "rgba(224, 185, 61, 0.15)" },
  Qp: { border: "#796dce", background: "rgba(121, 109, 206, 0.15)" }
};

const options = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    },
    y: {
      beginAtZero: true,
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    }
  },
  plugins: {
    legend: { display: false }
  }
};

type Props = {
  currency: string;
  history: ItemPriceHistoryEntry[];
};

const ItemPriceHistoryChart = ({ currency, history }: Props) => {
  const colors = CURRENCY_COLORS[currency] || {
    border: "#98d8ff",
    background: "rgba(152, 216, 255, 0.15)"
  };

  return (
    <Line
      options={options}
      data={{
        labels: history.map(h => new Date(h.soldAt).toLocaleDateString()),
        datasets: [
          {
            label: `${currency} price`,
            data: history.map(h => h.soldPrice),
            borderColor: colors.border,
            backgroundColor: colors.background,
            tension: 0.2
          }
        ]
      }}
    />
  );
};

export default ItemPriceHistoryChart;
